export const BOOKING_SHIPMENTS_ROUTE_PREFIX: string = '/dashboard/booking-shipments';

interface BookingShipmentsRoutes {
  details: {
    getUrl: (id: string, tab?: string) => string;
    path: string;
    relativePath: string;
  };
  index: {
    getUrl: (tabSlug?: string, scopeSlug?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingShipmentsRoutes: BookingShipmentsRoutes = {
  details: {
    path: `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/details/:id/:tab?`,
    getUrl: (id: string, tab?: string): string => {
      const url: string = `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/details/${id}`;

      if (!tab) {
        return url;
      }

      return `${url}/${tab}`;
    },
    relativePath: 'booking-shipments/details/:id/:tab?'
  },
  index: {
    path: `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/:tab?/:scope?`,
    getUrl: (tabSlug?: string, scopeSlug?: string): string => {
      if (!tabSlug) {
        return BOOKING_SHIPMENTS_ROUTE_PREFIX;
      }

      const tabUrl: string = `${BOOKING_SHIPMENTS_ROUTE_PREFIX}/${tabSlug}`;

      if (!scopeSlug) {
        return tabUrl;
      }

      return `${tabUrl}/${scopeSlug}`;
    },
    relativePath: 'booking-shipments/:tab?/:scope?'
  }
};

export default bookingShipmentsRoutes;
